import { Injectable } from '@angular/core';

@Injectable()
export class AdminService {
  newCriterionOn = false
  newTagOn = false
  newSearchTermOn = false
  newTopicOn = false
  uploadSearchFilesOn = false
  uploadBatchSearchOn = false

  constructor() { }

  clearSwitches() {
    this.newCriterionOn = false
    this.newTagOn = false
    this.newSearchTermOn = false
    this.newTopicOn = false
    this.uploadSearchFilesOn = false
    this.uploadBatchSearchOn = false
  }

}



// WEBPACK FOOTER //
// ./src/app/admin.service.ts